export function StatCard({ label, value, sub, accent, testid }) {
  return (
    <div className="ldc-glass ldc-glass-hover p-5 relative overflow-hidden" data-testid={testid}>
      <div className="text-[10px] tracking-[0.28em] uppercase text-white/40">{label}</div>
      <div className={`mt-3 font-display text-3xl tracking-tight ${accent ? "text-[#fbce18]" : "text-white"}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-white/50">{sub}</div>}
    </div>
  );
}

export function SectionTitle({ eyebrow, title, right }) {
  return (
    <div className="flex items-end justify-between mb-4">
      <div>
        {eyebrow && <div className="text-[10px] tracking-[0.28em] uppercase text-[#fbce18]/80">{eyebrow}</div>}
        <h2 className="mt-1 font-display text-2xl tracking-tight">{title}</h2>
      </div>
      {right}
    </div>
  );
}

export function Empty({ title = "Nothing here yet", desc }) {
  return (
    <div className="ldc-glass p-10 text-center">
      <div className="font-display text-lg">{title}</div>
      {desc && <div className="mt-2 text-sm text-white/50">{desc}</div>}
    </div>
  );
}
